import UmmIAPlanTitleImg from "../../components/UmmIACategories/img/UmmIAPlanTitleImg.png";
import HeaderCategoria from "../../components/UmmIACategories/HeaderCategoria";
import AppsContainer from "../../components/UmmIACategories/AppsContainer";

const UmmiaPlanPage = () => {
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="UmmIAPlan"
        descripcion="Tu planificador de clases inteligente y creativo"
        img={UmmIAPlanTitleImg}
        alt="Imagen UmmIA Plan"
        primaryColor="#278C62"
        secondaryColor="#A9D1C0"
        thirdColor="#52A381"
      />

      {/* Contenedor de tarjetas: se renderizan solo las apps a las que el usuario tiene acceso */}
      <AppsContainer filter="UmmIAPlan" />
    </>
  );
};

export default UmmiaPlanPage;
